function IntegrationTablesController($scope, $window, IntegrationAppService) {
    var ctrl = this;

    this.$onInit = function () {
        //console.log('onInit');        
        //ctrl.sortTimers();

        /*
        ctrl.tableModes = [];
        ctrl.tableModes.push('IMEDIATE');
        ctrl.tableModes.push('WEBJOB');
        */

        ctrl.loadIntegrs();
    };

    this.$onChanges = function (changes) {
        console.log('onChanges');        
        //console.log(changes);
        if (changes) {
            ctrl.sortTimers();
        }

    
    };

    ctrl.sortTimers = function () {

    };

    ctrl.loadIntegrs = function () {
        //$scope.error = false;
        ctrl.loading = true;
        IntegrationAppService.getIntegrTableIDs().then(function (result) {
            if (result) {
                ctrl.options = result.data;
                //$scope.logMsg = $scope.integrs.length + ' integrações';
            }
            ctrl.loading = false;
        }, function (error) {
            ctrl.loading = false;
            console.log(error);
        });
    };

    ctrl.add = function () {
        console.log('add tables');

        if (!ctrl.tables) {
            ctrl.tables = [];
        }

        var table = { TableID: null, ExecMarka: true, ExecIntegration: true };
        ctrl.tables.push(table);

        /*
        ctrl.timers.push({
            TimerMonday: true, TimerTuesday: true, TimerWednesday: true, TimerThursday: true, TimerFriday: true,
            RowState: 'New'
        });
        */

        //console.log('addTimer');
        ctrl.editing = true;
    };

    ctrl.remove = function ($index) {
        ctrl.tables.splice($index, 1);
    };

    ctrl.hasTimers = function () {
        if (ctrl.tables) {
            return ctrl.tables.length > 0;
        }
        else {
            return false;
        }
    };
}


seedWebApp.component('integrationTables', {
    controller: IntegrationTablesController,
    bindings: {
        tables: '<',
        readOnly: '<',
        size: '@'
    },
    templateUrl: './SPA/Integrations/integrationTables.html'
});

